module.exports = "h1{\r\n\tpadding-top: 50px;\r\n}"